module.exports = __webpack_public_path__ + "img/u83.d1205ae6.svg";